import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewType } from "../../utils/util";
import GalleryView from "./video-layouts/galleryView";
import ActiveSpeakerExcluding from "./video-layouts/activeSpeakerExcluding";
import PresentationView from "./video-layouts/presentationView";
import ActiveSmallWindow from "./video-layouts/activeSmallWindow";
import AudioContainer from "./video-layouts/audioContainer";
import { ShowActiveSpeakerOnFirstPage } from "../../utils/functions";
import { calculateGallerySize } from "../../utils/functions";
import { setLastView, setView, setWindowDimension } from "../../reduxStore/confSlice";
import AudienceMode from "./video-layouts/audienceMode";


const VideoContainer = () => {
  const dominantSpeaker = useSelector((state) => state.conf.dominantSpeaker);
  const view = useSelector((state) => state.conf.view);
  const maxVideos = useSelector((state) => state.conf.maxVideos);
  const screenSharedJid = useSelector((state) => state.conf.screenSharedJid);
  const mediaShareparticipantsJID = useSelector((state) => state.conf.mediaShareparticipantsJID);
  const extensionDetails = useSelector((state) => state.conf.extensionDetails);
  const activeSmallWindowHide = useSelector((state) => state.conf.activeSmallWindowHide);
  const videoContainerSettings = useSelector((state) => state.conf.videoContainerSettings);
  const windowDimension = useSelector((state) => state.conf.windowDimension);
  const chatClick = useSelector((state) => state.conf.chatClick);
  const widgetClick = useSelector((state) => state.conf.widgetClick);
  const attendeesClick = useSelector((state) => state.conf.attendeesClick);
  const galleryViewParticipants = useSelector((state) => state.conf.galleryViewParticipants);
  const roomDetail = useSelector((state) => state.conf.roomDetail);

  const isFirstRender = useRef(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const setWindowSize = () => {
      const { innerHeight, innerWidth } = window;

      dispatch(
        setWindowDimension({
          ...{
            clientWidth: innerWidth,
            clientHeight: innerHeight,
          },
        })
      );
    };
    setWindowSize();
    window.addEventListener("resize", setWindowSize);
    return () => {
      window.removeEventListener("resize", setWindowSize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const galleryViewParticipantsCount = useMemo(() => {
    return view === viewType?.gallery ? galleryViewParticipants.length : 1;
  }, [galleryViewParticipants, view]);

  const showActiveWindow = useMemo(() => {
    let imageShared = extensionDetails?.extensionid === 52199 && extensionDetails?.type?.includes("image");
    let show = videoContainerSettings?.show_speaker_on_presentation && !activeSmallWindowHide && ((view === viewType.presentation && screenSharedJid !== mediaShareparticipantsJID) || imageShared);
    return show;
  }, [videoContainerSettings?.show_speaker_on_presentation, view, extensionDetails, mediaShareparticipantsJID, screenSharedJid, activeSmallWindowHide]);

  useEffect(() => {
    ShowActiveSpeakerOnFirstPage(showActiveWindow);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dominantSpeaker, maxVideos]);

  useEffect(() => {
    dispatch(calculateGallerySize(galleryViewParticipantsCount));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [galleryViewParticipantsCount, windowDimension, chatClick, attendeesClick, widgetClick]);

  useEffect(() => {
    console.log('currentView', view);
    if (view === viewType.presentation) {
      dispatch(setLastView(roomDetail.recorder_view));
    } else {
      console.log('roomDetail?.recorder_view', roomDetail?.recorder_view);
      dispatch(setView(roomDetail?.recorder_view));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomDetail?.recorder_view]);

  const renderView = () => {
    switch (view) {
      case "gallery":
        return <GalleryView showActiveWindow={showActiveWindow} />;
      case "active":
        return <ActiveSpeakerExcluding largeWindow={true} showActiveWindow={showActiveWindow} />;
      case "presentation":
        return <PresentationView showActiveWindow={showActiveWindow} />;
      case 'audience':
        return <AudienceMode showActiveWindow={showActiveWindow} />;
      default:
        return <GalleryView showActiveWindow={showActiveWindow} />;
    }
  };

  return (
    <>
      <AudioContainer />

      {renderView()}

      {showActiveWindow && (
        <ActiveSmallWindow>
          <ActiveSpeakerExcluding showActiveWindow={showActiveWindow} />
        </ActiveSmallWindow>
      )}
    </>
  );
};
export default React.memo(VideoContainer);
